import { render } from "./LandingSlider.vue?vue&type=template&id=26c4c1f6"
import script from "./LandingSlider.vue?vue&type=script&lang=js"
export * from "./LandingSlider.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__